<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Li Lingao
 * @Date: 2020-08-20 17:31:39
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-09-17 18:23:15
-->
<template>
  <div class="right-chart-1">
    <dv-border-box-13>
      <dv-decoration-7 style="width:150px;height:30px;font-size:18px;">入厅部门</dv-decoration-7>
      <div class="lc1-details">
        部门总数
        <span>45</span>个
      </div>
      <dv-scroll-board :config="config" style="width:100%;height:320px" />
    </dv-border-box-13>
  </div>
</template>

<script>
import ns from "@/services/NetService.js"
export default {
  name: 'RightChart1',
  data() {
    return {
      config: {
        data: [
          ['<span style="color:#242424;">烟台市生态环境局</span>'],
          ['<span style="color:#242424;">烟台市退役军人局</span>'],
          ['<span style="color:#242424;">烟台市总工会</span>'],
          ['<span style="color:#242424;">烟台市卫生健康委</span>'],
          ['<span style="color:#242424;">烟台市侨办</span>'],
          ['<span style="color:#242424;">烟台市发展改革委</span>'],
          ['<span style="color:#242424;">烟台市教育局</span>'],
          ['<span style="color:#242424;">烟台市科技局</span>'],
          ['<span style="color:#242424;">烟台市公安局</span>'],
          ['<span style="color:#242424;">烟台市民政局</span>'],
          ['<span style="color:#242424;">烟台市司法局</span>'],
          ['<span style="color:#242424;">烟台市财政局</span>'],
          ['<span style="color:#242424;">烟台市人力资源和社会保障局</span>'],
          ['<span style="color:#242424;">烟台市住建局</span>'],
          ['<span style="color:#242424;">烟台市城管局</span>'],
          ['<span style="color:#242424;">烟台市交通运输局</span>'],
          ['<span style="color:#242424;">烟台市水利局</span>'],
          ['<span style="color:#242424;">烟台市海洋发展和渔业局</span>'],
          ['<span style="color:#242424;">烟台市商务局</span>'],
          ['<span style="color:#242424;">烟台市审计局</span>'],
          ['<span style="color:#242424;">烟台市民族宗教局</span>'],
          ['<span style="color:#242424;">烟台市体育局</span>'],
          ['<span style="color:#242424;">烟台市统计局</span>'],
          ['<span style="color:#242424;">烟台市人防办</span>'],
          ['<span style="color:#242424;">烟台市住房公积金管理中心</span>'],
          ['<span style="color:#242424;">烟台市机关事务局</span>'],
          ['<span style="color:#242424;">烟台市档案局</span>'],
          ['<span style="color:#242424;">烟台市保密局</span>']

        ],
        oddRowBGC: '#fff',
        evenRowBGC: '#C0C0C0',
        waitTime: 1500,
        hoverPause: false,
        //color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b']
      }
    }
  }
}


</script>

<style lang="less">
.right-chart-1 {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;

  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }
  .lc1-details {
    height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;
    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }
  .rc1-chart-container {
    flex: 1;
    display: flex;
  }

  .left {
    width: 30%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 34px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    flex: 1;
    padding-bottom: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
</style>
